import { Box } from '@mui/material';
import Joyride from "react-joyride";

const STATUS = {
  FINISHED: 'finished',
  SKIPPED: 'skipped',
};

const AddTour = ({ addTour }) => {

    const handleJoyride = (event) => {
        const { action, status, type } = event;

        const finished =
            (action === "reset" && status === STATUS.FINISHED) ||
            (action === "reset" && status === "finished") ||
            type === "tour:end";

        if (finished) {
           addTour.set(false)
        }
    };

    const steps = [
        {
            target: '.upload-logo-btn',
            title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                        <Box fontWeight={100}>Company Logo</Box>
                         <Box >1/12</Box>
                    </Box>,
            content: (
            <Box fontSize={16} fontWeight={400}>
                Click here to upload a company logo .
            </Box>
            ),
            disableBeacon: true,
            placement: 'right'
        },

        {
            target: '.upload-banner-btn',
            title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                        <Box fontWeight={100}>company banner</Box>
                         <Box >2/12</Box>
                    </Box>,
            content: (
                <Box fontSize={16} fontWeight={400} >
                        Click here to upload your company banner.
                </Box>
            ),
            disableBeacon: true,
            placement: 'right'
        },

   {
    target: '.position-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Position</Box>
                <Box >3/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
            Enter <strong>Job Position</strong>  you need to hire.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },
   {
    target: '.company-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Company name</Box>
                <Box >4/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
          Enter the <strong>Company Name</strong> 
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },
   {
    target: '.qualification-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Qualification</Box>
                <Box >5/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
            Specify the education, skills and certifications needed.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.description-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Description</Box>
                <Box >6/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
        Provide summary of the role and responsibilities
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.perks-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Perks and Benefits</Box>
                <Box >7/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
        Add employee perks and program offered by your company.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.employment-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Employment Arrangement</Box>
                <Box >8/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
            Select employment type for this position.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.deployment-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Deployment Arrangement</Box>
                <Box >9/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
            Specify where and how employee will work.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.location-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Location</Box>
                <Box >10/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
           Add the office, branch or site for this position
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

   {
    target: '.overview-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Company Overview</Box>
                <Box >11/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
            Add company overview like mision and vision.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },

  {
    target: '.save-field',
    title: <Box display='flex' justifyContent='space-between' color='#bdb9b9ff' fontSize={14} fontWeight={400}>
                <Box fontWeight={100}>Save</Box>
                <Box >12/12</Box>
            </Box>,
    content: (
      <Box fontSize={16} fontWeight={400}>
           Post the job to start recieving application.
      </Box>
    ),
    disableBeacon: true,
    placement: 'right'
  },


    ];

    const Tourstyle = () => ({
        options: {
            zIndex: 1202,
            borderRadius: "15px",
            width: "380px",
        },

       spotlight: {
            borderRadius: '4px',
            padding: '20px',
            width: '200px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            border: '2px solid white',
        },
        buttonClose: {
            display: "none",
        },
        buttonNext: {
            fontFamily: "Inter",
            fontWeight: 500,
            backgroundColor: "#03A36E",
            padding: "8px",
            fontSize: "12px !important",
            borderRadius: "15px",
            color: "#fff",
            cursor: "pointer",
            textAlign: "center",
            width: "80px",
            height: "33px",
        },
        buttonSkip: {
            fontFamily: "Inter",
            fontWeight: 500,
            padding: "8px",
            fontSize: "12px !important",
            color: "#A3A3A3",
            cursor: "pointer",
            textAlign: "center",
            width: "80px",
            height: "33px",
            marginRight: "2px",
            float: "right",
        },
        tooltip: {
            minHeight: "140px",
            borderRadius: "15px",
        },
        tooltipFooter: {
            marginTop: 0,
            padding: "0px 16px",
            minHeight: "40px",
        },
        tooltipContent: {
            padding: "10px",
        },
        overlay: {
            height: "100%",
        },
    });

    return (
        <Box>
            <Joyride
                steps={steps}
                styles={Tourstyle()}
                run={addTour.data}
                showSkipButton
                continuous
                hideBackButton
                locale={{ skip: "Close", last: "Got it" }}
                callback={handleJoyride}
            />
        </Box>
    );
};

export default AddTour;